<div
  class="toaster"
  [class.success]="status() === TOASTER_STATUS.SUCCESS"
  [class.error]="status() === TOASTER_STATUS.ERROR"
  [class.info]="status() === TOASTER_STATUS.INFO"
  [class.clickable]="clickHandler()"
  (click)="onCardClick()"
  data-testid="toaster"
>
  <div class="header">
    <app-icon class="icon" [path]="icon()" [size]="24" aria-hidden="true" />
    <div class="title typography-body-medium">{{ title() }}</div>
    <button
      type="button"
      class="close-button"
      [attr.aria-label]="'CLOSE' | translate"
      (click)="$event.stopPropagation(); close()"
    >
      <app-icon [path]="'assets/img/close.svg'" [size]="24" aria-hidden="true" />
    </button>
  </div>
  @if (subtitle() || message()) {
    <div class="body">
      @if (subtitle()) {
        <div class="subtitle typography-small-regular">{{ subtitle() }}</div>
      }
      @if (message()) {
        <div class="message typography-small-regular">{{ message() }}</div>
      }
    </div>
  }
  <ng-content />
  @if (action(); as toastAction) {
    <button app-button variant="secondary" (click)="onActionClick($event)">
      {{ toastAction.label }}
    </button>
  }
</div>
